import { withStyles } from '@material-ui/core';

import Breadcrumbs from './component';
import styles from './styles';

export { default as Breadcrumb } from './Breadcrumb';

export default withStyles(styles)(Breadcrumbs);
